// Premium site themes: gradient stops for the fixed page backdrop.
export const THEMES = [
    { name: 'null', colors: ['#111111', '#111111'] },
    { name: 'По умолчанию', colors: ['#111111', '#111111'] },
    { name: 'Магический остров', colors: ['#052029', '#160f22', '#131313', '#0e0e0e'] },
    { name: 'Конец Евангелиона', colors: ['#330305', '#1a170c', '#131313', '#0e0e0e'] },
    { name: 'Малиновый закат', colors: ['#1e0624', '#220c18', '#131313', '#0e0e0e'] },
    { name: 'Карибские глубины', colors: ['#061e24', '#0c2219', '#131313', '#0e0e0e'] },
    { name: 'Летающий замок', colors: ['#1d7085', '#13291f', '#131313', '#0e0e0e'] },
    { name: 'Ночь в Токио', colors: ['#1c023a', '#1d1329', '#131313', '#0e0e0e'] },
];

export const DEFAULT_THEME = THEMES[0];

export const getSavedTheme = () => {
    const savedName = localStorage.getItem('theme');
    return THEMES.find((theme) => theme.name === savedName) || DEFAULT_THEME;
};
